
import React, {useState, useEffect} from "react";
import HeroScreen from "./HeroSection";
import DetailsSection from "./DetailsSection";
import FeatureIcons from "./FeatureIcons";
import TestimonialSection from "./TestamonialList";
import BlogSection from "./Blogs";
import SubscribeSection from "./SubscribeSection";
import SoulmateCTASection from "./SoulmateCTASection";
import CongratulationsPopup from "./SubscribePopUp";
import baseURL from "../../authComponents/baseURL/BaseURL";
import loginToken from "../../authComponents/localStorageItems/LoginTokin";
import PricingPlans from "./PricingPlans";

const Homepage = () => {
    const [content, setContent] = useState("");
    useEffect(() => {
      const fetchAnnouncement = async () => {
        try {
          const response = await baseURL.get("/admin/announcement", {
            headers: {
              Authorization: `Bearer ${loginToken}`,
            },
          });
          const data = response.data?.announcement;
          setContent(data?.content || "");
        } catch (err) {
          console.error("Error fetching announcement:", err);
        }
      };
  
      fetchAnnouncement();
    }, []);
  return (
    <>
      <div className="flex items-center p-3 m-0 bg-black">
        <div className="w-full md:w-1/12 text-white text-right font-semibold announcement-text-box">
          Announcement:
        </div>
        <div className="flex flex-col items-end w-full md:w-10/12 text-white px-7 announcement-line-container" style={{fontFamily:"serif"}}>
          <marquee>
            {content}
          </marquee>
        </div>
      </div>

      <HeroScreen />
      <div className="py-6"></div>
      <CongratulationsPopup />
      <div className="py-6"></div>
      <FeatureIcons />
      <div className="py-6"></div>
      <DetailsSection />
      <div className="py-6"></div>
      {/* <ProfileList /> */}
      <TestimonialSection />
      <div className="py-6"></div>
      <PricingPlans />
      <SubscribeSection />
      <SoulmateCTASection />
    </>
  );
};


export default Homepage;
